import * as React from 'react';
import { FormikHelpers as FormikActions, Formik, FormikProps } from 'formik';
import { TwsAdmin } from '@weddingspot/ws-api-client';
import { SpinnerOverlay } from '@weddingspot/ws-core-components';

import { AvailabilityFormData } from './types';
import { defaultAvailabilityFormData } from './constants';
import { anyTouched } from '../../utils/formik';
import AvailabilityGeneralCard from './AvailabilityGeneralCard';
import DayOfEventCard from './DayOfeventCard';

interface OwnProps {
    /* Form data */
    currentVenue: TwsAdmin.AvailableVenue;
    choicesLoaded: boolean | null;
    choices: TwsAdmin.AvailabilityFormChoices | null;
    valuesLoaded: boolean | null;
    initialValues: AvailabilityFormData | null;

    /* Form handlers */
    onSubmit: (formData: AvailabilityFormData, formikActions: FormikActions<AvailabilityFormData>) => Promise<void>;

    // Notify parent that an initialization error occurred
    onInitError: () => void;

    // Notify parent that a form error occurred
    onFormError: () => void;

    // Notify parent that form was successfully submitted
    onFormSuccess: () => void;

    // Notify parent that form was touched
    setTouched: (touched: boolean) => void;
}

export class Availability extends React.Component<OwnProps> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        const { choices, choicesLoaded, valuesLoaded, initialValues } = this.props;

        return (
            <div className='VenueManagement--availability'>
                <Formik
                    initialValues={initialValues || defaultAvailabilityFormData}
                    enableReinitialize={true}
                    validate={() => {
                        const errors: Partial<AvailabilityFormData> = {};
                        return errors;
                    }}
                    onSubmit={this.props.onSubmit}
                >
                    {(formikProps: FormikProps<AvailabilityFormData>) => {
                        const { values, handleChange, handleSubmit, setFieldValue, touched, isSubmitting } = formikProps;

                        this.props.setTouched(anyTouched(touched));

                        if (typeof window !== 'undefined') {
                            window.onbeforeunload = () => {
                                if (anyTouched(touched)) {
                                    // NOTE: Chromium browsers diabled custom messages
                                    // including this here in case the target browser
                                    // still supports this :(
                                    return 'You have unsaved changes! Are you sure' + ' you want to leave before saving them?';
                                }

                                return;
                            };
                        }

                        const buttonSpinnerProps = {
                            isSpinning: isSubmitting,
                            spinnerProps: {
                                spinnerColor: '#881155',
                                spinnerDiameter: 40,
                            },
                        };

                        const cardSpinnerProps = {
                            isSpinning: isSubmitting || choicesLoaded === null || valuesLoaded === null,
                            spinnerProps: {
                                spinnerColor: '#881155',
                                spinnerDiameter: 60,
                            },
                        };

                        return (
                            <div>
                                <form onSubmit={handleSubmit} className='VenueManagement--availability-form'>
                                    <div className='VenueManagement--body-header'>
                                        <div className='VenueManagement--body-header-title'>Availability</div>
                                        {!!formikProps.status && (
                                            <div className='VenueManagement--field-level-error'>{formikProps.status}</div>
                                        )}
                                        <div className='VenueManagement--body-header--submit-container'>
                                            <SpinnerOverlay {...buttonSpinnerProps}>
                                                <button
                                                    type='submit'
                                                    className='VenueManagement--form-submit nx-button nx-button--primary'
                                                    disabled={!choicesLoaded || !valuesLoaded}
                                                >
                                                    Save
                                                </button>
                                            </SpinnerOverlay>
                                        </div>
                                    </div>
                                    <SpinnerOverlay {...cardSpinnerProps}>
                                        <AvailabilityGeneralCard
                                            choicesLoaded={choicesLoaded}
                                            choicesData={choices}
                                            valuesLoaded={valuesLoaded}
                                            formikProps={formikProps}
                                        />
                                    </SpinnerOverlay>
                                    <SpinnerOverlay {...cardSpinnerProps}>
                                        <DayOfEventCard
                                            choicesLoaded={choicesLoaded}
                                            choicesData={choices}
                                            valuesLoaded={valuesLoaded}
                                            formikProps={formikProps}
                                        />
                                    </SpinnerOverlay>
                                    <div className='VenueManagement--body-footer'>
                                        <div className='VenueManagement--body-footer--submit-container'>
                                            <SpinnerOverlay {...buttonSpinnerProps}>
                                                <button
                                                    type='submit'
                                                    className='VenueManagement--form-submit nx-button nx-button--primary'
                                                    disabled={!choicesLoaded || !valuesLoaded}
                                                >
                                                    Save
                                                </button>
                                            </SpinnerOverlay>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        );
                    }}
                </Formik>
            </div>
        );
    }
}
